module.exports = __webpack_public_path__ + "static/media/glass-whiskey-rocks.93a39e8e.svg";